import { render, staticRenderFns } from "./scoreboard.vue?vue&type=template&id=514c3d4b"
import script from "./scoreboard.vue?vue&type=script&lang=js"
export * from "./scoreboard.vue?vue&type=script&lang=js"
import style0 from "./scoreboard.vue?vue&type=style&index=0&id=514c3d4b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports